function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import styled from "styled-components";
import forwardRef from "../../../private/forwardRef";
import { nanoid } from "nanoid/non-secure";
var StyledSVG = styled.svg.withConfig({
  displayName: "LinkedinLg__StyledSVG",
  componentId: "sc-1ivhgqa-0"
})(["width:1.5rem;height:1.5rem;"]);
var LinkedinLg = forwardRef(function (props, ref) {
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(StyledSVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": props != null && props.title ? titleId : undefined
  }, props), (props == null ? void 0 : props.title) && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, props.title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.027 9H13l.05 1.467h.057C13.66 9.417 14.984 8.5 17 8.5c4.196 0 5 2.402 5 6V22h-4v-6.607c0-1.55-.373-3.393-2.5-3.393-2.156 0-2.5 1.65-2.5 3.393V22H9.027V9ZM4.404 2a2.406 2.406 0 0 1 2.402 2.408 2.406 2.406 0 0 1-2.402 2.408A2.405 2.405 0 0 1 2 4.408 2.405 2.405 0 0 1 4.404 2ZM2.5 22h4V9h-4v13Z",
    fill: "currentColor"
  }));
});
LinkedinLg.displayName = "LinkedinLg";
export default LinkedinLg;